'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import { Popover, PopoverContent, PopoverTrigger } from '@repo/ui/components/ui/popover';
import { cn } from '@repo/ui/lib/utils';
type InfoTipProps = Pick<PopoverPrimitive.Trigger.Props, 'aria-label' | 'children' | 'nativeButton' | 'render'> & {
  className?: string;
  content: React.ReactNode;
  contentClassName?: string;
  side?: React.ComponentProps<typeof PopoverContent>['side'];
};

// Base UI disables tooltips on touch, so info icons use a hover-opening popover that also opens on tap.
function InfoTip(t0) {
  const $ = _c(21);
  let className;
  let content;
  let contentClassName;
  let t1;
  let triggerProps;
  if ($[0] !== t0) {
    ({
      className,
      content,
      contentClassName,
      side: t1,
      ...triggerProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = content;
    $[3] = contentClassName;
    $[4] = t1;
    $[5] = triggerProps;
  } else {
    className = $[1];
    content = $[2];
    contentClassName = $[3];
    t1 = $[4];
    triggerProps = $[5];
  }
  const side = t1 === undefined ? "top" : t1;
  let t2;
  if ($[6] !== className) {
    t2 = cn("relative after:absolute after:-inset-3 md:after:hidden", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2 || $[9] !== triggerProps) {
    t3 = <PopoverTrigger className={t2} data-slot="info-tip-trigger" delay={0} onClick={_temp} openOnHover={true} {...triggerProps} data-sentry-element="PopoverTrigger" data-sentry-source-file="info-tip.tsx" />;
    $[8] = t2;
    $[9] = triggerProps;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== contentClassName) {
    t4 = cn("inline-flex w-fit max-w-xs items-center gap-1.5 rounded-md border-0 bg-foreground px-3 py-1.5 text-xs text-background shadow-none", contentClassName);
    $[11] = contentClassName;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PopoverPrimitive.Arrow className="z-50 size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground data-[side=bottom]:top-1 data-[side=left]:top-1/2! data-[side=left]:-right-1 data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-1 data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-2.5" data-sentry-element="PopoverPrimitive.Arrow" data-sentry-source-file="info-tip.tsx" />;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== content || $[15] !== side || $[16] !== t4) {
    t6 = <PopoverContent className={t4} data-slot="info-tip-content" side={side} data-sentry-element="PopoverContent" data-sentry-source-file="info-tip.tsx">{content}{t5}</PopoverContent>;
    $[14] = content;
    $[15] = side;
    $[16] = t4;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t6) {
    t7 = <Popover data-sentry-element="Popover" data-sentry-component="InfoTip" data-sentry-source-file="info-tip.tsx">{t3}{t6}</Popover>;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
function _temp(event) {
  return event.stopPropagation();
}
export { InfoTip };